import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NavService } from '../../../../services/nav.service';
import { NgxSpinnerService } from 'ngx-spinner';
import PaginationOptions from '../../../../models/PaginationOptions';
import * as Global from '../../../../global';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { DatePipe, NgIf } from '@angular/common';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { HelpersService } from '../../../../services/helpers.service';
import { MatBadgeModule } from '@angular/material/badge';
import { ToastService } from '@app/services/toast.service';
import { MatDialog } from '@angular/material/dialog';
import { MultiAttachmentComponent } from '../../material/multi-attachment/multi-attachment.component';
import { TripService } from '../../../../services/trip.service';

@Component({
  selector: 'trip-activity',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatIconModule,
    MatButtonModule,
    NgxSkeletonLoaderModule,
    DatePipe,
    InfiniteScrollModule,
    MatBadgeModule,
    NgIf,
  ],
  templateUrl: './trip-activity.component.html',
  styleUrl: './trip-activity.component.scss',
})
export class TripActivityComponent {
  @Input() data: any = null;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;
  isLoading: boolean = false;
  Global = Global;
  paginationOptions: PaginationOptions;
  log_list: any = [];
  imgErrorIds: Set<any> = new Set();
  formGroup!: FormGroup;
  ActionType: any = 'Activity';
  constructor(
    private helpers: HelpersService,
    public toastr: ToastService,
    public navService: NavService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private tripService: TripService
  ) {
    this.paginationOptions = Global.resetPaginationOptions();
  }
  ngOnChanges() {
    this.fetchTripTrackings();
    this.formGroup = this.fb.group({
      tripId: [this.data?.trip_id],
      // tripItineraryId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
      actionBy: [this.helpers.userId()],
      actionDate: [new Date()],
      // status: 'string',
      remarks: [null, Validators.compose([Validators.required])],
      actionType: ['Remarks'],
      // tripTypeName: [null],
      imageUrlData: [null],
      fileName: [null],
    });
  }
  onRemarkAdd() {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      const sentAt = new Date();
      this.formGroup.patchValue({ actionDate: sentAt });
      const optimisticItem = {
        id: 'temp-' + sentAt.getTime(),
        actionByName: this.helpers.userDetails()?.name,
        actionDate: sentAt,
        remarks: this.formGroup.value.remarks,
        imageUrl: null,
        profilePhoto: null,
      };
      this.log_list = [...this.log_list, optimisticItem];
      this.scrollToBottom();
      this.tripService.addTripRemarks(this.formGroup.value).subscribe({
        next: (res) => {
          this.formGroup.patchValue({
            remarks: null,
            imageUrlData: null,
            fileName: null,
          });
          this.paginationOptions = {
            ...Global.resetPaginationOptions(),
            pageSize: Math.max(this.paginationOptions.totalCount + 5, 20),
          };
          this.ActionType = 'Remarks';
          this.fetchTripTrackings(false);
          this.formGroup.markAsUntouched();
          // setTimeout(() => {
          //   Global.scrollToQuery('#' + res?.id);
          // }, 1000);
        },
        error: (err) => {
          this.log_list = this.log_list.filter(
            (item: any) => item?.id !== optimisticItem.id
          );
        },
      });
    }
  }
  // onTabChanged(event: MatTabChangeEvent) {
  //   this.paginationOptions = Global.resetPaginationOptions();
  //   if (event.index == 0) {
  //     this.ActionType = 'Activity';
  //   } else {
  //     this.ActionType = 'Remarks';
  //   }
  //   this.fetchTripTrackings();
  // }
  fetchTripTrackings(showSkeleton: boolean = true) {
    const isInitialLoad = this.paginationOptions.skip === 0;
    const showSpinner = isInitialLoad && !showSkeleton;
    if (isInitialLoad && showSkeleton) {
      this.isLoading = true;
    }
    const el = this.scrollContainer?.nativeElement;
    const prevScrollHeight = el?.scrollHeight ?? 0;
    const prevScrollTop = el?.scrollTop ?? 0;
    let params = new URLSearchParams();
    this.ActionType = 'Remarks';
    params.set('ActionType', this.ActionType);
    params.set('TripId', this.data?.trip_id);
    if ((this.ActionType = 'Remarks')) {
      params.set('OrderBy', 'createdDate desc');
    }
    params.set('pageSize', String(this.paginationOptions.pageSize));
    params.set('skip', String(this.paginationOptions.skip));
    if (showSpinner) {
      this.spinner.show();
    }
    this.tripService.fetchTripTrackings({ params }).subscribe({
      next: (res: any) => {
        this.appendItems(res.data);
        this.paginationOptions = {
          skip: res?.pagingData?.skip ?? 0,
          pageSize: res?.pagingData?.pageSize ?? 10,
          totalCount: res?.pagingData?.totalCount ?? 0,
          totalPages: res?.pagingData?.totalPages ?? 0,
        };
        if (isInitialLoad) {
          this.scrollToBottom();
        } else {
          this.preserveScrollPosition(prevScrollHeight, prevScrollTop);
        }
      },
      error: (err: any) => {
        if (showSpinner) {
          this.spinner.hide();
        }
        this.isLoading = false;
      },
      complete: () => {
        if (showSpinner) {
          this.spinner.hide();
        }
        this.isLoading = false;
      },
    });
  }
  private scrollToBottom() {
    setTimeout(() => {
      const el = this.scrollContainer?.nativeElement;
      if (el) {
        el.scrollTop = el.scrollHeight;
      }
    });
  }
  private preserveScrollPosition(prevScrollHeight: number, prevScrollTop: number) {
    setTimeout(() => {
      const el = this.scrollContainer?.nativeElement;
      if (el) {
        el.scrollTop = el.scrollHeight - prevScrollHeight + prevScrollTop;
      }
    });
  }
  appendItems(items: any = []) {
    if (this.paginationOptions.skip == 0) {
      this.log_list = items;
    } else {
      const existingIds = new Set(this.log_list.map((item: any) => item?.id));
      items.forEach((item: any) => {
        if (!existingIds.has(item?.id)) {
          this.log_list.push(item);
        }
      });
    }
    this.log_list.sort(
      (a: any, b: any) =>
        new Date(a?.actionDate).getTime() - new Date(b?.actionDate).getTime()
    );
  }
  onImageError(id: any) {
    this.imgErrorIds.add(id);
  }
  onScroll() {
    if (
      this.paginationOptions.totalCount >
      this.paginationOptions.skip + this.paginationOptions.pageSize
    ) {
      this.paginationOptions.skip =
        this.paginationOptions.skip + this.paginationOptions.pageSize;
      this.fetchTripTrackings();
    }
  }
  viewAttachment(
    item: any,
  ) {
    this.dialog
      .open(MultiAttachmentComponent, {
        data: {
          type: 'Attachment',
          folderPath: '/TrackingDocument/',
          existing: [{
            receiptName: item?.imageUrl,
            receiptPath: item?.imageUrl,
          }],
          multi: true,
          view_only: true
        },
        disableClose: true,
      })
  }
}
